import { ClickableAITag } from "component/aitag";
import { CLICK, component, demoFile, POPUP, story, variant, componentWithVariants } from "system/demo";

demoFile('feature/question/ai-tag');

componentWithVariants('ClickableAITag', ClickableAITag, {}, [
    variant(null, {}, [
        story('Click on tag and open Community Guidelines', [
            CLICK('ai-moderated-tag'),
            POPUP(CLICK('Community Guidelines'))
        ])
    ])
])
